import React, { useEffect } from "react";

export function PrivacyPolicy() {
    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth';
        return () => {
            document.documentElement.style.scrollBehavior = '';
        };
    }, []);

    return (
        <div className="App">
            <div className="App-background">
                <div className="App-base" style={{ backgroundColor: 'white' }}>
                    <div className="App-body">
                        <div style={{ textAlign: 'center', paddingTop: '2em' }}>
                            <span style={{ color: '#333' }}>プライバシーポリシー</span>
                        </div>
                        <div style={{ color: '#333', padding: '1em', wordBreak: 'break-all' }}>
                            <p>アプリ事業開発（カンテイモバイル）部門</p>
                            <p>アプリ事業開発部門の「個人情報の保護に関する法律」に基づく公表事項</p>
                            <p>株式会社東京カンテイ　アプリ事業開発部門は、「個人情報の保護に関する法律」（以下「法」といいます）に基づき、以下の事項を公表致します。</p>
                            <br />
                            <p>1. 個人情報取扱い事業者の名称等<br />
                                名称：株式会社　東京カンテイ　代表取締役　長田　千江美<br />
                                住所：東京都品川区上大崎３－８－３</p>
                            <br />
                            <p>2. 利用目的の公表</p>
                            <p>アプリ事業開発部門等が直接取得する個人情報は、取得の状況からみて利用目的が明らかであると認められる場合を除き、その利用目的を通知または公表若しくは明示致します。また、アプリ事業開発部門等が間接的に取得し保有する個人データは、次の目的に利用させていただきます。</p>
                            <ol>
                                <li>アプリ事業開発等において必要なサービスを提供するため。</li>
                                <li>前(1)の利用目的達成のために必要な情報提供をするため。</li>
                                <li>不動産市場の、需給や価格動向等の分析並びに公表するため。</li>
                                <li>その他付帯サービス等を実施するための内容等を、郵便または電子メール等で案内するため。</li>
                            </ol>
                            <br />
                            <p>2-2. ご利用端末のGPS機能及びその他の位置情報測位機能を利用した位置情報及びその取得時刻、その状態の取得について</p>
                            <p>取得方法 ： アプリケーションによる自動取得</p>
                            <p>利用目的 ： ランドマークの近隣を通過する際、アプリからその旨の通知を発信する為。ご利用者様が識別されない形式で位置情報統計データを活用する為。</p>
                            <p>また、本アプリでは端末の移動状態を検知して位置情報取得を最適化する場合があります。</p>
                            <p>この機能は位置情報取得の精度向上およびバッテリー消費の削減のために使用されるものであり、歩数・心拍数等の健康データやフィットネスデータの収集は行っておりません。</p>
                            <br />
                            <p>3. 開示・訂正・削除（消去）・利用停止等に係る手続き</p>
                            <p>開示・訂正・削除（消去）・利用停止等の手続きについては、<a href="#p2" rel="noreferrer">こちら</a>をご参照ください。</p>
                            <br />
                            <p>4. 第三者提供</p>
                            <p>アプリ事業開発部門等は、法に基づく場合、または利用目的の達成に必要な範囲内において、不動産の物件概要と価格または賃料に係る情報を、Faxまたはオンライン若しくは郵便等で、第三者に提供することがあります。</p>
                            <p>但し、第三者に提供されるデータは、個人が容易に特定できないように加工して提供されます。</p>
                            <p>なお、ご本人からのお申出により、ご本人に関する情報であることが確認されたのちに、当該ご本人が識別できるデータの提供は停止します。お申し出の手続きは、<a
                                href="#p2" rel="noreferrer">こちら</a>をご参照下さい。</p>
                            <br />
                            <p>5. 業務委託</p>
                            <p>利用目的の達成に必要な範囲内において、また秘密保持契約等の必要な保護措置を講じたうえで、個人情報の取り扱いの全部または一部を外部に委託することがあります。</p>
                            <br />
                            <p>6. 苦情および相談の受付窓口について</p>
                            <p>株式会社東京カンテイ　アプリ事業開発部門等への個人情報のお取り扱いに関する苦情または相談は、下記までお願い致します。</p>
                            <p>経営企画室　個人情報担当<br />
                                Tel　03(3442)3011<br />
                                Fax　03(5719)2914<br />
                                受付時間　午前9時30分～午後5時30分　(土曜日、日曜日、祝祭日、年末年始を除く)
                            </p>
                            <br />
                            <p id="p2">開示等の求めに応じる手続きについて</p>
                            <br />
                            <p>1. 開示等のお申し出先</p>
                            <p>「開示等の求め」は、次に掲げる所定の申請書に必要書類を添付のうえ、下記送付先までご郵送でご請求ください。</p>
                            <p>なお、封筒に「開示等請求書類在中」とお書き添えいただければ幸いです。</p>
                            <br />
                            <p>＜送付先＞<br />
                                株式会社東京カンテイ　経営企画室　個人情報担当<br />
                                〒141-0021　東京都品川区上大崎2丁目24番15号　目黒西口ビル
                            </p>
                            <p>＜申請書＞<br />
                                (1) 保有個人データ開示申請書　(<a href="https://mansionlibrary.jp/pdf/P-A.pdf" target="_blank" rel="noreferrer">開示等様式A</a>)<br />
                                (2) 保有個人データ訂正等申請書　(<a href="https://mansionlibrary.jp/pdf/P-B.pdf" target="_blank" rel="noreferrer">開示等様式B</a>)<br />
                                (3) 保有個人データ利用停止等申請書　(<a href="https://mansionlibrary.jp/pdf/P-C.pdf" target="_blank" rel="noreferrer">開示等様式C</a>)<br />
                                (4) 保有個人データ第三者提供停止申請書　(<a href="https://mansionlibrary.jp/pdf/P-D.pdf" target="_blank" rel="noreferrer">開示等様式D</a>)
                            </p>
                            <br />
                            <p id="p2-2">2. ご本人確認等のための書類等</p>
                            <p>「開示等の求め」を行われる場合は、ご本人の情報であることを確認するために、次に掲げる書類等を申請書に添付してご提出ください。</p>
                            <p>(1) 運転免許証、マイナンバーカード、旅券、健康保険証、外国人登録証明書の写しのいずれかひとつ</p>
                            <p>(2) 印鑑証明書 (申請書に押印された印鑑に係るもの)</p>
                            <p>(3) 当該保有個人データと、ご本人との関係を証する資料等 (注)</p>
                            <p>(注)アプリ事業開発部門等では、ご依頼者等の情報を除き、氏名、生年月日、電話番号等の直接個人を特定できる情報は保有しておりません。従いまして、氏名等で直接個人を特定できる情報の開示等の請求を除き、ご本人との関係を証する資料等の提出をお願いしております。</p>
                            <br />
                            <p id="p2-3">3. 代理人による開示等の求めについて</p>
                            <p>「開示等の求め」をする方が、未成年者または成年被後見人の法定代理人若しくは「同求め」をすることについてご本人が委託した代理人の方の場合は、上記「ご本人確認等のための書類等(1)から(3)」に加えて、次に掲げる(1)または(2)の書類を必ず同封してご請求ください。</p>
                            <p>(1) 法定代理人の場合</p>
                            <p>・法定代理権があることを確認させていただくための書類 (戸籍謄本等)</p>
                            <p>・次に掲げる法定代理人ご本人であることを確認させていただくための書類</p>
                            <p>①運転免許証、マイナンバーカード、旅券、健康保険証、外国人登録証明書の写しのいずれかひとつ</p>
                            <p>②印鑑証明書 (申請書に押印された印鑑にかかるもの)</p>
                            <p>(2) 委任による代理人の場合</p>
                            <p>・委任状 (ご本人の実印を押印したもの)</p>
                            <p>・次に掲げる法定代理人ご本人であることを確認させていただくための書類</p>
                            <p>② 運転免許証、マイナンバーカード、旅券、健康保険証、外国人登録証明書の写しのいずれかひとつ</p>
                            <p>②印鑑証明書 (申請書に押印された印鑑にかかるもの)</p>
                            <br />
                            <p>4. 手数料等</p>
                            <p>一請求につき、300円＋消費税とさせていただきます。所定の金額分の郵便切手を申請書類にご同封ください。</p>
                            <br />
                            <p>5. 開示等の求めによるご回答方法</p>
                            <p>ご申請者の申請者記載住所宛に、書面によってご回答致します。</p>
                            <br />
                            <p>6. 開示等の求めに関して取得した個人情報の利用目的および保存期間</p>
                            <p>「開示等の求め」により取得した個人情報は、「同求め」に対応するために必要な範囲内でお取り扱いさせていただきます。</p>
                            <p>なお、ご提出いただいた書類は、「同求め」に対する回答日より2年間保存し、その後廃棄致します。</p>
                            <br />
                            <p>7. 不開示事由について</p>
                            <p>次に定める場合は、不開示とさせていただきます。不開示と決定した場合は、できる限り理由を付記してご通知致します。また、不開示の場合につきましても、所定の手数料をいただきます。</p>
                            <ol>
                                <li>開示の求めの対象が、法で定義する保有個人データに該当しない場合</li>
                                <li>ご本人または第三者の生命、身体、財産その他の権利利益を害する恐れがある場合</li>
                                <li>他の法令に違反することとなる場合</li>
                                <li>弊社の業務の適正な実施に著しい支障を及ぼす恐れがある場合</li>
                                <li>ご本人の個人情報の存在が認められない場合</li>
                                <li>代理人による申請に際して、代理権が確認できない場合</li>
                                <li>所定の申請書類に、不備や虚偽がある場合</li>
                            </ol>
                            <br />
                            <p>第三者提供の停止について</p>
                            <p>1. 停止のお申し出先</p>
                            <p>「停止のお申し出」は、次に掲げる所定の申請書に必要書類を添付のうえ、下記送付先まで郵送でご請求ください。</p>
                            <p>なお、封筒に「停止請求書類在中」とお書き添えいただければ幸いです。</p>
                            <br />
                            <p>＜送付先＞</p>
                            <p>株式会社東京カンテイ　経営企画室　個人情報担当</p>
                            <p>〒141-0021　東京都品川区上大崎2丁目24番15号　目黒西口ビル</p>
                            <br />
                            <p>＜申請書＞</p>
                            <p>保有個人データ第三者提供停止申請書　(<a href="https://mansionlibrary.jp/pdf/P-E.pdf" target="_blank" rel="noreferrer">開示等様式E</a>) オプトアウト</p>
                            <br />
                            <p>2. ご本人確認等のための書類等</p>
                            <p>「停止のお申し出」を行われる場合は、ご本人の情報であることを確認するために、「<a href="#p2-2" rel="noreferrer">ご本人確認等のための書類等</a>」項に掲げる書類等を申請書に添付してご提出ください。</p>
                            <br />
                            <p>3. 代理人による停止のお申し出について</p>
                            <p>「停止のお申し出」をする方が、未成年者または成年被後見人の法定代理人もしくは「同お申し出」をすることについてご本人が委託した代理人の方の場合は、上記の「ご本人確認等のための書類等」に加えて、「<a href="#p2-3" rel="noreferrer">代理人による開示等の求めについて</a>」項に掲げる書類等を同封してご請求ください。</p>
                            <br />
                            <p>4. 停止のお申し出による処理結果のご案内方法</p>
                            <p>ご申請者の申請者記載住所宛に、書面によってご回答致します。</p>
                            <br />
                            <p>5. 停止のお申し出に関して取得した個人情報の利用目的および保存期間</p>
                            <p>「停止のお申し出」にともなって取得した個人情報は、「開示等の求めに関して取得した個人情報の利用目的および保存期間」と同様のお取り扱いをさせていただきます。</p>
                            <br />
                            <p>6. その他</p>
                            <p>次に定める場合は、「停止のお申し出」がありましても停止致しません。あらかじめご諒承ください。</p>
                            <p>なお、停止しないと決定した場合は、できる限り理由を付記してご通知致します。</p>
                            <ol>
                                <li>ご本人の個人情報の存在が認められない場合</li>
                                <li>代理人による申請に際して、代理権の確認ができない場合</li>
                                <li>所定の申請書類に、不備や虚偽がある場合</li>
                            </ol>
                            <p>以上</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}